<div *ngIf="showRequiredActions" class="card">
  <div class="card-body">
    <h4 id="custom-required-actions-title" class="card-title text-center text-danger">{{ 'required_client_actions' | translate }}</h4>
    <p id="custom-required-actions-subheader" class="text-secondary">{{ 'required_client_actions_sub' | translate }}</p>
    <div class="list-group">
      <template #requiredActionContent></template>
    </div>
  </div>
</div>